<template>
  <div id="questionview">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <h1>Questions Admin</h1>
      </v-row>
    </v-container>
    <div>
      <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <div class="filtersub">
       <!-- 
       <div class="first">
         <v-select
          :items="categorylist"
           v-model="category"
           label="Select Category"
           item-text="primary_category"
           item-value="id"
           outlined></v-select>
       </div>
       -->
       <div class="second">
          <v-text-field  v-model="search"  label="Type Question or option(answers)" class="mx-4 searchplayer"></v-text-field> 
       </div> 
       <div class="third">
           <v-btn color="primary text-center" @click.prevent="searchdata">Search</v-btn>
       </div>
    </div>
    <!--  :search="search"  -->
     <v-data-table 
       :headers="headers" 
       :mobile-breakpoint="0" 
       :items="itemsWithSno"  
      
       hide-default-footer  
       disable-pagination>
       <template v-slot:item="{ item }"  >
         <tr :class="item.color">
          <td>{{ item.id }}</td>
          <td class="text-left">
            {{ item.question }}
            <div class="options">
              <div v-if="item.option_a">A. {{item.option_a}}</div> 
              <div v-if="item.option_b">B. {{item.option_b}}</div>
              <div v-if="item.option_c">C. {{item.option_c}}</div>
              <div v-if="item.option_d">D. {{item.option_d}}</div>
            </div>
          </td>
          <td><v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon></td>
        </tr>
      </template>   
     </v-data-table>
     <infinite-loading  @infinite="getList"></infinite-loading>
    </div>
    <v-dialog v-model="dialog" max-width="650px">
     <v-card>
      <v-card-title>
        <span>Edit Question</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field v-model="editedItem.question" label="Question"></v-text-field>
            </v-col>
          </v-row>
           <div class="d-flex radio-single-sec">
              <div class="first">Correct Answer</div>
              <div class="second">Options</div>
            </div>
          <div class="optionshere">
           <v-radio-group v-model="optionval">
            <div class="d-flex radio-single-sec">
              <div class="first"><v-radio value="A"></v-radio></div>
              <div class="second" >
                <v-text-field v-model="editedItem.option_a" label="Option A"></v-text-field>
              </div> 
            </div>    
            <div class="d-flex radio-single-sec">
              <div class="first"><v-radio value="B"></v-radio></div>
              <div class="second" >
                  <v-text-field v-model="editedItem.option_b" label="Option B"></v-text-field>
              </div>
            </div>    
            <div class="d-flex radio-single-sec">
              <div class="first"><v-radio value="C"></v-radio></div>
              <div class="second" >
                  <v-text-field v-model="editedItem.option_c" label="Option C"></v-text-field>
              </div>
            </div>    
            <div class="d-flex radio-single-sec">
              <div class="first"><v-radio value="D"></v-radio></div>
              <div class="second" >
                  <v-text-field v-model="editedItem.option_d" label="Option D"></v-text-field>
              </div>
            </div>
            </v-radio-group> 
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
      </v-card-actions>
     </v-card>
    </v-dialog>
  </div>  

</template>
<script>
export default {
  name: "Questionview",
  data() {
    return {
      mobileBreakpoint: 600,
      dialog:false,
      error: false,
      errorText:'',
      desserts:[],
      editedItem:[],
      search:'', 
      page:1,
      categorylist:'',
      category:'',
      overlay: false,
      optionval:''
    };
  },
  computed: {
     headers(){
        let headers = [
              { text:"#", value: "sno" },
              { text:"Question  ",align: "question",value: "question",sortable: true},
              { text:"Action", value: "" },
         ]
         return headers
      },
       itemsWithSno() {
          return this.desserts.map((d, index) => ({ ...d, sno: index + 1,keyval:index }))
       },
  },
  created(){
     this.getCategories();
  },
  methods: {
    close(){
       this.editedItem = [];
       this.dialog     = false;
    },  
    save(){
      var questionid = this.editedItem.id;
      var question   = this.editedItem.question;
      var optiona    = this.editedItem.option_a;
      var optionb    = this.editedItem.option_b;
      var optionc    = this.editedItem.option_c;
      var optiond    = this.editedItem.option_d;
      
      this.$store.dispatch("updateQuestion",
        {
          "id":questionid,"question":question,
          "optiona":optiona,
          "optionb":optionb,
          "optionc":optionc,
          "optiond":optiond,
          "answer" :this.optionval,
        }).then(() => {
         this.dialog = false;
      });
    },
    editItem(item){
       this.editedItem = item;
       this.optionval  = this.editedItem.answer;
       this.dialog     = true;
    },
    searchdata(){
       var parameter = "";
       if(this.category != '')
       {
         parameter = parameter+"category_d="+this.category;
       }

       if(this.search != '')
       {
         parameter = parameter+"&question_string="+this.search;
       } 
       this.overlay = true;
       //this.desserts = [];
       this.$store.dispatch("getQuestionsList",{paramters:parameter}).then((response) => 
       {
          this.desserts = response.data;
          this.overlay = false;
       });
    }, 
    getList($state)
    {
       var parameter = "page="+this.page;
       if(this.category != '')
       {
         parameter = parameter+"&category_d="+this.category;
       }

       if(this.search != '')
       {
         parameter = parameter+"&question_string="+this.search;
       } 
       
       this.$store.dispatch("getQuestionsList",{paramters:parameter}).then((response) => {
          if(response.data.length > 0)
          {
             this.page += 1;
             this.desserts.push(...response.data);
             $state.loaded();
          }
          else
          {
            $state.complete();
          }
       });
     },
     getCategories(){
       this.$store.dispatch("getQuestionCategories").then((response) => {
          this.categorylist = response.data;
       });
     }
  }
};
</script>
<style scoped>
.options {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    margin-bottom: 8px;
}
.radio-single-sec {align-items: center;}
.filtersub{display:flex; width:98%;margin:auto;align-items: center;}
.filtersub div.first{flex: 0 0 20%}
.filtersub div.second{flex: 0 0 91%}
.filtersub div.third{flex: 0 0 10%}
.radio-single-sec .first {flex: 0 0 15%;}
.radio-single-sec .second {flex: 0 0 85%;}

</style>